import React from 'react';
import { observer } from 'mobx-react-lite';
import InfluencerPerformanceSelector from './InfluencerPerformanceSelector'
import { currencyFormat, separateThousands } from '../../../../../../utils/Helper'
import { CheckCircle, DashCircle } from 'react-bootstrap-icons'
export default observer(function InfluencerRowStats({ infActions, formProps, performance }) {
  const actionsReach = infActions.reduce((acc, action) => acc + action.action_insight.reach, 0)
  const impressions = infActions.reduce((acc, action) => acc + (action.action_insight.impressions || action.action_insight.story_first_sequence_impressions), 0)
  const likes = infActions.reduce((acc, action) => acc + action.action_insight.likes, 0)
  const comments = infActions.reduce((acc, action) => acc + action.action_insight.comments, 0)
  const saves = infActions.reduce((acc, action) => acc + action.action_insight.saves, 0)
  const engRate = (likes + comments + saves) / (actionsReach * infActions.length) || 0
  const followerCount = infActions.reduce((acc, action) => acc + action.reach, 0)

  const price = infActions.reduce((acc, action) => acc + action.advertiserPrice, 0).toFixed(2)
  const cpmFollower = (price / followerCount) * 1000
  const cpmImpression = (price / impressions) * 1000
  const costEngRate = price / (likes + comments + saves)

  return (
    <tr>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 sticky left-0 z-10 bg-white dark:bg-rb-dark-mode min-w-[200px]">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">
            <img src={infActions[0].avatar} alt="influencer avatar" className="w-7 h-7 rounded-full object-cover" />
          </span>
          <span className="font-bold text-md dark:text-white">
            {infActions[0].auth_username}
          </span>
        </div>
      </td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode">
        {
          performance ? (
            <div className="flex justify-center gap-8">
              {
                performance.performance === 'good' ? (
                  <div className="flex gap-2 items-center justify-center">
                    <CheckCircle className="font-bold text-rb-green" />
                    <p className="text-sm dark:text-white">Good</p>
                  </div>
                ) : performance.performance === 'adequate' ? (
                  <div className="flex gap-2 items-center justify-center">
                    <DashCircle className="font-bold text-rb-black dark:text-white" />
                    <p className="text-sm dark:text-white">Average</p>
                  </div>
                ) : (
                  <p className="text-sm dark:text-white">No rating</p>
                )
              }
            </div>
          ) : (
            <InfluencerPerformanceSelector influencerId={infActions[0].influencer_id} formProps={formProps} />
          )
        }
      </td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(followerCount)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(actionsReach)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(impressions)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(likes)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(comments)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{separateThousands(saves)}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{(engRate * 100).toFixed(2)}%</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{currencyFormat(price, '€')}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{currencyFormat(cpmFollower.toFixed(2), '€')}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{currencyFormat(cpmImpression.toFixed(2), '€')}</td>
      <td className="text-sm border-1 border-border-primary dark:border-rb-dark-mode-lighter px-2 py-1 min-w-[100px] dark:bg-rb-dark-mode dark:text-white">{currencyFormat(costEngRate.toFixed(2), '€')}</td>
    </tr>
  )
})